import styled from 'styled-components';
import {
  screenSize,
  whiteColor,
  appFontColor,
  mediumFont,
  regularFont,
} from '@app/styles';
import Logo from '@app/assets/images/munitechlogo.png';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background: #ffffff;
  border-radius: 8px;
  margin: 60px 0px 0px 0px;
  @media (${screenSize.tablet}) {
    margin: 120px auto 50px;
    width: 800px;
    display: block;
  }
`;
export const InnerContainer = styled.div`
  width: 100%;
  padding: 30px 15px 15px;
  position: relative;
  height: calc(100vh - 60px);
  overflow-y: auto;
  overflow-x: hidden;
  @media (${screenSize.tablet}) {
    padding: 85px 0 0;
    height: 634px;
    display: flex;
    justify-content: start;
    flex-direction: column;
    background: ${whiteColor};
    box-shadow: rgb(100 112 119 / 20%) 0px 5px 10px 0px;
    border-radius: 8px;
    input {
      border-color: #ccc;
    }
  }
`;
export const Row = styled.div`
  width: 100%;

  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    // margin-top:20px;
    padding: 15px 15px 0;
  }
`;
export const RowItem = styled.div`
  width: 100%;
  position: relative;
  margin: 25px 0;
  @media (${screenSize.tablet}) {
    width: 50%;
    padding: 0 15px;
    margin: 0;
  }
`;

export const Heading = styled.div`
  color: ${appFontColor};
  text-align: center;
  padding: 15px;
  font-size: 24px;
  ${mediumFont};
  @media (${screenSize.tablet}) {
    border-bottom: 2px solid #dce0e8;
    height: 60px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: start;
  }
`;

export const Footer = styled.div`
  border-top: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column-reverse;
  @media (${screenSize.tablet}) {
    border-top: 1px solid #bdc3c7;
    padding: 0 20px;
    height: 90px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    flex-direction: row;
  }
`;
export const ButtonContainer = styled.div`
  width: 100%;

  @media (${screenSize.tablet}) {
    width: 165px;
  }
`;
export const CancelButton = styled.div`
  margin-top: 30px;
  cursor: pointer;
  font-size: 15px;
  @media (${screenSize.tablet}) {
    margin-right: 30px;
    margin-top: 0;
  }
`;
export const Text = styled.p`
  color: ${appFontColor};
  text-align: center;
  a {
    font-size: inherit;
  }
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const ErrorMessage = styled.p`
  font-size: 14px;
  ${regularFont};
  color: #ec4160;
  margin: 0;
  position: absolute;
  bottom: -22px;
  @media (${screenSize.tablet}) {
    bottom: 0;
  }
`;
export const SideHeading = styled.p`
  font-size: 16px;
  ${mediumFont};
  border-bottom: 2px solid #dce0e8;
  color: #33394c;
  padding: 0px 0px 10px;
  margin: 0 30px 20px;
`;
export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
export const UploadContainer = styled.div`
  margin-bottom: 30px;
  width: 100%;

  @media (${screenSize.tablet}) {
    height: 86px;
    width: 740px;
    margin: 0 10px;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }
`;
export const Label = styled.label`
  color: #818589;
  font-size: 0.8rem;
  ${mediumFont}
  line-height: 21px;
  padding: 5px 0;
  @media (${screenSize.tablet}) {
    text-align: left;
    width: 100%;
    margin: 0 35px;
  }
`;
export const Item = styled.div`
  width: 100%;
  position: relative;
  margin: 25px 0;
  @media (${screenSize.tablet}) {
    width: 100%;
    padding: 0 15px;
    margin: 0;
  }
`;
export const MunitechLogo = styled.div`
  width: 30px;
  height: 30px;
  position: absolute;
  margin-left: 10px;
  border-radius: 8px;
  margin-right: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url(${Logo});
`;
